import { render, staticRenderFns } from "./SocialEntityEdit.vue?vue&type=template&id=5f5969f3&"
import script from "./SocialEntityEdit.js?vue&type=script&lang=js&"
export * from "./SocialEntityEdit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports